import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffIdSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={27} height={16} viewBox="0 0 27 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M21.388 8.15c0-.73-.42-1.162-1.425-1.162h-.898v2.35h.898c1.007 0 1.425-.514 1.425-1.188"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.296 1h12.408C23.734 1 27 4.134 27 8s-3.267 7-7.296 7H7.296C3.266 15 0 11.866 0 8s3.267-7 7.296-7m4.796 3.599h-7.86v3.793c0 .972.54 1.87 1.419 2.357l2.511 1.391 2.512-1.391c.877-.486 1.418-1.385 1.418-2.357zm4.488 5.78V5.92h-1.465v4.457zm6.302-2.23c0 1.283-.917 2.23-2.771 2.23h-2.46V5.92h2.616c1.697 0 2.615.946 2.615 2.229"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.39 6.595v1.18c.168-.183.473-.306.822-.306h.38V8.84c0 .365-.103.684-.257.86h1.652c-.152-.176-.255-.495-.255-.859V7.47h.379c.35 0 .656.123.823.306v-1.18H6.388z"
            fill="currentColor"
        />
    </svg>
));
TinkoffIdSolidSize16Glyph.displayName = 'TinkoffIdSolidSize16Glyph';
